import {sidebar} from './Sidebar/en'

export const layout = {
  ...sidebar,
}
